import { combineReducers } from 'redux'
import { createSelector } from 'reselect'
import { user } from './user/user'
import { error } from './user/error'
import { companies } from './company/companies'
import { inventory } from './inventory/inventory'
import { SET_LOGOUT } from '../actions/user'
import { initialState } from '../store'

const appReducers = combineReducers({
    user,
    error,
    companies,
    inventory
})

const rootReducer = (state, action) => {
    if (action.type === SET_LOGOUT) {
        state = initialState
    }
    return appReducers(state, action)
}

export default rootReducer

export const getUser = createSelector(state => state.user, user => user)
export const getError = createSelector(state => state.error, error => error)
export const getCompanies = createSelector(state => state.companies, companies => companies)
export const getInventory = createSelector(state => state.inventory, inventory => inventory)
